import { Navigate, Route, Routes } from 'react-router-dom'

import { delmanRouteElements } from '@/router/delmanRoutes'
import { kitchenRouteElements } from '@/router/kitchenRoutes'
import { RootRedirect } from '@/router/RootRedirect'
import { buildAppMode } from '@/shared/buildMode'
import { ServiceWorkerRegister } from '@/shared/pwa/ServiceWorkerRegister'

export function AppRouter() {
  return (
    <>
      <ServiceWorkerRegister />
      <Routes>
        <Route path="/" element={<RootRedirect />} />

        {buildAppMode === 'kitchen' && (
          <>
            <Route path="/delman/*" element={<Navigate to="/kitchen" replace />} />
            {kitchenRouteElements}
          </>
        )}

        {buildAppMode === 'delman' && (
          <>
            <Route path="/kitchen/*" element={<Navigate to="/delman" replace />} />
            {delmanRouteElements}
          </>
        )}

        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </>
  )
}
